import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding-top: 16px;

  .ant-empty {
    margin: 56px 8px;
  }

  .ant-collapse-header {
    border-radius: 8px;
  }

  .ant-collapse-content {
    border-top: none !important;
  }
`;
